import { combineEpics } from 'redux-observable'
import { loadCryptoRewardsOrdersList } from 'components/features/rewards/rewardsPane/store/epics/orders/loadCryptoRewardsOrdersList'

export const cryptoRewardsEpicOrders = combineEpics(
  loadCryptoRewardsOrdersList
)
